import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FindReplaceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"find_replace"}/>
}
